import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { cn } from '@/utils/cn';
import styles from './SpeedDropdown.module.scss';
import type { SpeedDropdownProps } from './SpeedDropdown.types';

const DEFAULT_OPTIONS: readonly number[] = [0.5, 0.75, 1, 1.25, 1.5] as const;

function formatSpeed(speed: number): string {
  return `${speed}x`;
}

/**
 * SpeedDropdown — pill button that opens a dropdown to pick a playback speed.
 * Reusable for any audio/video element where the consumer manages the actual
 * playbackRate state.
 */
export function SpeedDropdown({
  speed,
  onSpeedChange,
  options = DEFAULT_OPTIONS,
  className,
  ariaLabel,
}: SpeedDropdownProps) {
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button
          type="button"
          className={cn(styles.trigger, className)}
          aria-label={ariaLabel ?? `Velocidad de reproducción: ${formatSpeed(speed)}`}
        >
          {formatSpeed(speed)}
        </button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content className={styles.menu} sideOffset={6} align="start">
          {options.map((s) => (
            <DropdownMenu.Item
              key={s}
              className={cn(
                styles.menuItem,
                s === speed && styles['menuItem--active']
              )}
              onSelect={() => onSpeedChange(s)}
            >
              {formatSpeed(s)}
            </DropdownMenu.Item>
          ))}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}

SpeedDropdown.displayName = 'SpeedDropdown';
